import { Link, __css, tokens } from '@fluentui/react-components';
import { useNavigate } from '@tanstack/react-router';
import { createContext, useContext, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** Provided by the frames that draw no shell pane: pages then draw their own title. */
export const StandaloneContext = createContext(false);

/** True inside `StandaloneFrame`: pages then draw their own title instead of the shell's pane header. */
export function useStandalone(): boolean {
  return useContext(StandaloneContext);
}

const useStyles = __css({"root":{"sshi5w":"f1qcbe8p","B7ck84d":"f1ewtqcl","Dbcxam":0,"rjzwhg":0,"Bblux5w":"fg89v1a","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fjshy37","De3pzq":"fxugw4r","sj55zd":"f19n0e5"},"column":{"B2u0y6b":"f1wm5lqa","Bokbzmb":0,"Jyy4pa":0,"B1u1w3b":"f1o88i5s","mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f13377fj"},"back":{"qb2dma":"fjgzulp"}});

/**
 * A user page outside the BatiFlow shell (no organisation yet): a centred column with a link back
 * to the home page, which sends the user on to onboarding.
 */
export function StandaloneFrame({ children }: { children: ReactNode }) {
  const styles = useStyles();
  const { t } = useTranslation('web');
  const navigate = useNavigate();
  return (
    <StandaloneContext.Provider value>
      <main className={styles.root}>
        <div className={styles.column}>
          <Link
            as="a"
            href="/"
            className={styles.back}
            onClick={(event) => {
              event.preventDefault();
              void navigate({ to: '/' });
            }}
          >
            {t('standalone.backHome')}
          </Link>
          {children}
        </div>
      </main>
    </StandaloneContext.Provider>
  );
}


import "/opt/batiflow/app/apps/web/src/shared/components/standalone-frame.griffel.css";